import { Slide } from "react-reveal";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const ICTTrainingFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How is learning at Uganda School of ICT different from traditional education?">
                  <p>
                    At Uganda School of ICT, learning is designed for real life.
                    Instead of theory-heavy, rigid systems, the focus is on:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Practical skills</span>
                    </li>
                    <li>
                      <span>Real-world application</span>
                    </li>
                    <li>
                      <span>Immediate usability</span>
                    </li>
                  </ul>
                  <p>
                    You gain skills you can apply instantly—not just academic
                    knowledge.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I have a clear path from beginner to advanced level?">
                  <p>Yes. Learning is structured into progressive packages:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Bronze → Foundation</span>
                    </li>
                    <li>
                      <span>Silver → Skill development</span>
                    </li>
                    <li>
                      <span>Gold → Advanced capability</span>
                    </li>
                    <li>
                      <span>Platinum → Specialization</span>
                    </li>
                  </ul>
                  <p>
                    You follow a clear, step-by-step journey from beginner to
                    professional level.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if I have no ICT background?">
                  <p>That’s completely fine. The Bronze level starts with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Basic digital skills</span>
                    </li>
                    <li>
                      <span>Simple, guided learning</span>
                    </li>
                  </ul>
                  <p>
                    You build confidence from the ground up and grow into a
                    fully capable ICT user and services provider.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I actually gain practical ICT skills?">
                  <p>Yes. Training is designed around:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Hands-on exercises</span>
                    </li>
                    <li>
                      <span>Real tasks</span>
                    </li>
                    <li>
                      <span>Practical application</span>
                    </li>
                  </ul>
                  <p>
                    You become confident using ICT tools in real-life
                    situations.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I learn how to use AI and modern tools?">
                  <p>
                    Yes. At the Platinum level, you move into specialization by
                    choosing a Career Path (Specialization Track) aligned with
                    real-world opportunities. You can choose a track from the
                    following categories:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>💻 Software & Development</span>
                    </li>
                    <li>
                      <span>🤖 AI, Data & Intelligent Systems</span>
                    </li>
                    <li>
                      <span>🎨 Design & Product</span>
                    </li>
                    <li>
                      <span>📈 Digital Business, Marketing & Sales</span>
                    </li>
                    <li>
                      <span>🎬 Media & Digital Production</span>
                    </li>
                    <li>
                      <span>☁️ Infrastructure & Systems Engineering</span>
                    </li>
                    <li>
                      <span>🔗 Systems, Operations & Tech Services</span>
                    </li>
                    <li>
                      <span>🔐 Security & Advanced Systems</span>
                    </li>
                  </ul>
                  <p>
                    Each path is designed to help you develop deep, practical,
                    and income-generating expertise. By the end, you are
                    equipped to:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Operate at a professional level</span>
                    </li>
                    <li>
                      <span>Deliver real-world solutions</span>
                    </li>
                    <li>
                      <span>
                        Generate income independently or within organizations
                      </span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Will I work on real projects or just learn theory?">
                  <p>You will work on real projects. Training includes:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Practical assignments</span>
                    </li>
                    <li>
                      <span>Real-world simulations</span>
                    </li>
                    <li>
                      <span>Guided project execution</span>
                    </li>
                  </ul>
                  <p>
                    You leave with skills you can apply immediately—not just
                    theory.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I build a portfolio or proof of my skills?">
                  <p>Yes. You will:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Create real outputs</span>
                    </li>
                    <li>
                      <span>Build practical projects</span>
                    </li>
                    <li>
                      <span>Document your work</span>
                    </li>
                  </ul>
                  <p>
                    You graduate with proof of your skills—not just knowledge.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the ICT and AI skills I acquire help me start earning?">
                  <p>
                    Yes. Every learning package is designed with one goal: To
                    help you start earning using your skills. You are guided
                    toward:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Practical application</span>
                    </li>
                    <li>
                      <span>Income opportunities</span>
                    </li>
                    <li>
                      <span>Career readiness</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="How quickly can I start seeing results?">
                  <p>
                    You begin applying skills as you learn. Because training is
                    practical:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>You don’t wait until the end</span>
                    </li>
                    <li>
                      <span>You start using skills early</span>
                    </li>
                  </ul>
                  <p>You can see real results during your learning journey.</p>
                </FaqCardList>
                <FaqCardList faq="Will I learn how to use real tools and systems?">
                  <p>Yes. You will train with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Real ICT tools</span>
                    </li>
                    <li>
                      <span>Practical systems</span>
                    </li>
                    <li>
                      <span>Industry-relevant platforms</span>
                    </li>
                  </ul>
                  <p>You become comfortable working with real-world tools.</p>
                </FaqCardList>
                <FaqCardList faq="Will I be able to work in a real digital environment after training?">
                  <p>Yes. You will learn:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Systems</span>
                    </li>
                    <li>
                      <span>Workflows</span>
                    </li>
                    <li>
                      <span>Digital tools</span>
                    </li>
                  </ul>
                  <p>
                    You gain the ability to operate confidently in real
                    workplaces or businesses.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Is the learning flexible if I can’t attend physically?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Attend physically</span>
                    </li>
                    <li>
                      <span>Join online</span>
                    </li>
                    <li>
                      <span>Switch between both</span>
                    </li>
                  </ul>
                  <p>Your learning remains consistent and uninterrupted.</p>
                </FaqCardList>
                <FaqCardList faq="Who teaches the programs?">
                  <p>Training is delivered by:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Active tech professionals</span>
                    </li>
                    <li>
                      <span>Practitioners</span>
                    </li>
                    <li>
                      <span>Entrepreneurs and builders</span>
                    </li>
                  </ul>
                  <p>
                    You learn from people who actually do the work—not just
                    teach theory.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the learning match my personal goals?">
                  <p>Yes. You:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Choose your learning package</span>
                    </li>
                    <li>
                      <span>Select your career path</span>
                    </li>
                  </ul>
                  <p>Your learning is aligned with your goals and direction.</p>
                </FaqCardList>
                <FaqCardList faq="Can I continue learning and improving after one level?">
                  <p>Yes. You can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Progress through packages</span>
                    </li>
                    <li>
                      <span>Advance into specialization</span>
                    </li>
                  </ul>
                  <p>Your growth continues as far as you want to go.</p>
                </FaqCardList>
                <FaqCardList faq="Does Uganda School of ICT offer training for teams or organizations?">
                  <p>Yes. Training is available for:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Staff teams</span>
                    </li>
                    <li>
                      <span>Institutions</span>
                    </li>
                    <li>
                      <span>Organizations</span>
                    </li>
                    <li>
                      <span>Schools</span>
                    </li>
                  </ul>
                  <p>Teams become more capable, efficient, and productive.</p>
                </FaqCardList>
                <FaqCardList faq="Will what I learn actually apply to real-world work?">
                  <p>Yes. Training is aligned with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Real industry practices</span>
                    </li>
                    <li>
                      <span>Practical workflows</span>
                    </li>
                    <li>
                      <span>Modern tools</span>
                    </li>
                  </ul>
                  <p>
                    Your skills translate directly into real work and
                    opportunities.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What is the main goal of the training programs?">
                  <p>The goal is clear:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        To help you build practical ICT and AI skills for life
                      </span>
                    </li>
                  </ul>
                  <p>Every package is designed with this outcome in mind.</p>
                </FaqCardList>
                <FaqCardList faq="What’s the difference between Bronze, Silver, Gold, and Platinum?">
                  <p>The difference is:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Depth of learning</span>
                    </li>
                    <li>
                      <span>Speed of progression</span>
                    </li>
                    <li>
                      <span>Level of specialization</span>
                    </li>
                  </ul>
                  <p>
                    Not whether you can succeed—but how far and how fast you go.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do I need expensive equipment to start learning?">
                  <p>No. You only need:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>A phone, tablet, or computer</span>
                    </li>
                    <li>
                      <span>Internet connection</span>
                    </li>
                  </ul>
                  <p>
                    You can start with minimal resources and grow from there.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How does this connect to real-world ICT work?">
                  <p>
                    Uganda School of ICT is part of a broader ICT ecosystem
                    where:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Real systems are built</span>
                    </li>
                    <li>
                      <span>Real tools are used</span>
                    </li>
                    <li>
                      <span>Real solutions are delivered</span>
                    </li>
                  </ul>
                  <p>
                    You gain skills that connect directly to real-world
                    application.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What happens after I complete the training?">
                  <p>You will be able to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Deliver real solutions</span>
                    </li>
                    <li>
                      <span>Work professionally</span>
                    </li>
                    <li>
                      <span>Earn independently or within organizations</span>
                    </li>
                  </ul>
                  <p>You transition from learning to real-world execution.</p>
                </FaqCardList>
                <FaqCardList faq="Is this suitable for beginners or experienced individuals?">
                  <p>Both.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Beginners → start from foundation</span>
                    </li>
                    <li>
                      <span>Experienced individuals → upgrade skills</span>
                    </li>
                  </ul>
                  <p>The learning adapts to your current level and goals.</p>
                </FaqCardList>
                <FaqCardList faq="Why should I choose Uganda School of ICT?">
                  <p>Because the focus is on what truly matters:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Practical skills</span>
                    </li>
                    <li>
                      <span>Real-world application</span>
                    </li>
                    <li>
                      <span>Income and career readiness</span>
                    </li>
                  </ul>
                  <p>
                    You don’t just learn—you become capable, confident, and
                    ready.
                  </p>
                </FaqCardList>
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ICTTrainingFaqsBody;
